import { NgModule } from '@angular/core';
import {ButtonComponent} from './button.component';
import {MatButtonModule} from '@angular/material/button';
import {CommonModule} from '@angular/common';

@NgModule({
  declarations: [
    ButtonComponent
  ],
  imports: [
    MatButtonModule,
    CommonModule
  ],
  exports: [
    ButtonComponent
  ]
})
export class ButtonModule { }
